import app from './ngmodule';
import { IWebServiceUrl } from "../common/web-service-url";

export interface ICurrentUserAccessor {
	current(): angular.IPromise<ICurrentUser>;
	hasLabel(label: string): angular.IPromise<boolean>;
	hasRole(role: string): angular.IPromise<boolean>;
	isAuthenticated(): angular.IPromise<boolean>;
	userId(): angular.IPromise<string>;
	username(): angular.IPromise<string>;
	email(): angular.IPromise<string>;
	clear(): void;
}

export interface ICurrentUser {
	authenticated: boolean;
	userId: string;
	username: string;
	email: string;
	authenticationType: string;
	roles: string[];
	tokenSub: string;
	labels: string[];
}

class CurrentUserAccessor implements ICurrentUserAccessor {
	private _user: angular.IPromise<ICurrentUser> | null = null;

	constructor(private $http: angular.IHttpService, private $q: angular.IQService, private webServiceUrl: IWebServiceUrl) {
	}

	current() {
		if (this._user == null) {
			this._user = this.$http.get<ICurrentUser>(this.webServiceUrl.api('account/getuser')).then(response => {
				return response.data;
			});
		}
		return this._user;
	}

	hasLabel(label: string) {
		return this.current().then(user => {
			return user.labels.includes(label);
		});
	}

	hasRole(role: string) {
		return this.current().then(user => {
			return user.roles.includes(role);
		});
	}

	clear() {
		this._user = null;
	}

	isAuthenticated() {
		return this.current().then(user => {
			return user.authenticated;
		});
	}

	userId() {
		return this.current().then(user => {
			return user.userId;
		});
	}

	username() {
		return this.current().then(user => {
			return user.username;
		});
	}

	email() {
		return this.current().then(user => {
			return user.email;
		});
	}
}

app.factory('vmCurrentUserAccessor', ['$http', '$q', 'webServiceUrl', function ($http: angular.IHttpService, $q: angular.IQService, webServiceUrl: IWebServiceUrl) {
	return new CurrentUserAccessor($http, $q, webServiceUrl);
}]);